module.exports = fox._r("images/tips-placeholder.gif", __webpack_public_path__ + "images/tips-placeholder.gif");


//////////////////
// WEBPACK FOOTER
// ./images/tips-placeholder.gif
// module id = 43
// module chunks = 4